import { isUndefined } from 'lodash';
import { STYLE_POSITION_ATTRIBUTES } from './constants';

/**
 * Returns a given variation root's position.
 * @param {Root} root
 * @returns {RootPosition}
 */
const getRootPosition = ({ style = {} } = {}) =>
    STYLE_POSITION_ATTRIBUTES.reduce(
        (acc, key) =>
            Object.assign(acc, {
                ...(!isUndefined(style[key]) && { [key]: Number(parseFloat(style[key])) }),
            }),
        {}
    );

export default getRootPosition;
